import { cva } from "@agapi/ui/panda/css";
export const buttonStyles = cva({
    base: {
        display: "flex",
        position: "relative",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        fontFamily: "body",
        textAlign: "center",
        fontWeight: "bold",
        borderRadius: "interactive",
        transition: "0.2s ease",
        _hover: {
            _disabled: {
                scale: 1,
            },
            scale: 1.02,
            transition: "0.3s ease-out",
        },
        _active: {
            _disabled: {
                scale: 1,
            },
            scale: 0.994,
            transition: "0.13s ease-out",
        },
        _focus: {
            outlineWidth: "2px",
            outlineColor: "action.primary.background.default",
            outlineOffset: "2px",
        },
        _disabled: {
            pointerEvents: 'none',
        }
    },
    variants: {
        variant: {
            cta: {
                backgroundColor: {
                    base: "action.cta.background.default",
                    _hover: "action.cta.background.hover",
                    _active: "action.cta.background.active",
                    _disabled: {
                        base: "action.disabled.background",
                        _active: "action.disabled.background",
                        _hover: "action.disabled.background",
                    }
                },
                color: {
                    base: "action.cta.foreground.default",
                    _disabled: "action.disabled.foreground",
                },
            },
            primary: {
                backgroundColor: {
                    base: "action.primary.background.default",
                    _hover: "action.primary.background.hover",
                    _active: "action.primary.background.active",
                    _disabled: {
                        base: "action.disabled.background",
                        _active: "action.disabled.background",
                        _hover: "action.disabled.background",
                    }
                },
                color: {
                    base: "action.primary.foreground.default",
                    _disabled: "action.disabled.foreground",
                },
            },
            secondary: {
                backgroundColor: {
                    base: "action.secondary.background.default",
                    _hover: "action.secondary.background.hover",
                    _active: "action.secondary.background.active",
                    _disabled: {
                        base: "action.disabled.background",
                        _active: "action.disabled.background",
                        _hover: "action.disabled.background",
                    }
                },
                color: {
                    base: "action.secondary.foreground.default",
                    _disabled: "action.disabled.foreground",
                },
            },
            text: {
                backgroundColor: "transparent",
                color: {
                    base: "action.text.foreground.default",
                    _hover: "action.text.foreground.hover",
                    _active: "action.text.foreground.active",
                    _disabled: {
                        base: "action.disabled.foreground",
                        _active: "action.disabled.foreground",
                        _hover: "action.disabled.foreground",
                    }
                },
            },
            destructive: {
                backgroundColor: {
                    base: "action.destructive.background.default",
                    _hover: "action.destructive.background.hover",
                    _active: "action.destructive.background.active",
                    _disabled: {
                        base: "action.disabled.background",
                        _active: "action.disabled.background",
                        _hover: "action.disabled.background",
                    }
                },
                color: {
                    base: "action.destructive.foreground.default",
                    _disabled: {
                        base: "action.disabled.foreground",
                        _active: "action.disabled.foreground",
                        _hover: "action.disabled.foreground",
                    }
                },
            },
        },
        size: {
            xs: {
                fontSize: "xs",
                px: "3",
                py: "2",
                gap: "2",
                leading: "tight",
            },
            sm: {
                fontSize: "sm",
                minHeight: "6",
                px: "4",
                py: "3",
                gap: "2",
                leading: "tight",
            },
            md: {
                fontSize: "md",
                gap: "3",
                px: "5",
                py: "4",
            },
            lg: {
                fontSize: "lg",
                gap: "4",
                px: "6",
                py: "5",
            },
            xl: {
                fontSize: "xl",
                gap: "5",
                px: "7",
                py: "6",
            },
        },
        fullWidth: {
            true: {
                width: "100%",
            },
        },
    },
    compoundVariants: [
        {
            size: ["xs", "sm", "md", "lg", "xl"],
            variant: "text",
            css: {
                px: "0",
                py: "0",
                borderRadius: "0",
            },
        },
    ],
});
